import { render } from "./organization_settings.vue?vue&type=template&id=189cdacc&scoped=true"
import script from "./organization_settings.js?vue&type=script&lang=js"
export * from "./organization_settings.js?vue&type=script&lang=js"

import "./organization_settings.vue?vue&type=style&index=0&id=189cdacc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189cdacc"]])

export default __exports__